'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var COLOR1 = 'red';
var COLOR2 = 'blue';

var LoadingFailedView = function (_Component) {
    _inherits(LoadingFailedView, _Component);

    function LoadingFailedView(props) {
        _classCallCheck(this, LoadingFailedView);

        var _this = _possibleConstructorReturn(this, (LoadingFailedView.__proto__ || Object.getPrototypeOf(LoadingFailedView)).call(this, props));

        _this.state = {
            color: COLOR1
        };

        _this.toggleColor = _this.toggleColor.bind(_this);
        return _this;
    }

    _createClass(LoadingFailedView, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var intervalId = setInterval(function () {
                _this2.toggleColor();
            }, 200);

            // eslint-disable-next-line
            this.setState({ intervalId: intervalId });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearInterval(this.state.intervalId);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                { style: { backgroundColor: this.state.color, fontSize: '25px' } },
                'Lazy module failed on load'
            );
        }
    }, {
        key: 'toggleColor',
        value: function toggleColor() {
            var newColor = void 0;
            if (this.state.color === COLOR1) {
                newColor = COLOR2;
            } else {
                newColor = COLOR1;
            }

            this.setState({ color: newColor });
        }
    }]);

    return LoadingFailedView;
}(_react.Component);

exports.default = LoadingFailedView;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/LoadingFailedView.js
// module id = 1302
// module chunks = 118